module.exports = __WEBPACK_EXTERNAL_MODULE_112__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 112
// module chunks = 0